import { render, staticRenderFns } from "./baseBindTeacher.vue?vue&type=template&id=70f49db8&"
import script from "./baseBindTeacher.vue?vue&type=script&lang=js&"
export * from "./baseBindTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports